module.exports = __webpack_public_path__ + "img/0.ecb182b2.png";